import { render, staticRenderFns } from "./StaticLandingPageStepWidgetContent.vue?vue&type=template&id=9efc96a4&scoped=true&"
import script from "./StaticLandingPageStepWidgetContent.vue?vue&type=script&lang=js&"
export * from "./StaticLandingPageStepWidgetContent.vue?vue&type=script&lang=js&"
import style0 from "./StaticLandingPageStepWidgetContent.vue?vue&type=style&index=0&id=9efc96a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efc96a4",
  null
  
)

export default component.exports